import {
  doc, getDoc, setDoc, serverTimestamp, increment, updateDoc
} from "firebase/firestore"
import { db } from "@/lib/firebase"

export interface Enrollment {
  userId: string
  courseId: string
  courseTitle: string
  courseFees: number
  courseType: "free" | "paid"
  courseImageUrl?: string
  instructor?: string
  duration?: string
  enrolledAt: any
  status: "active" | "pending" | "cancelled"
  // Payment fields — only for paid courses
  paymentId?: string
  paymentAmount?: number       // in ₹
  paymentCurrency?: string     // "INR"
  paymentOrderId?: string
  paymentSignature?: string
  paymentMethod?: string       // "razorpay" | "free"
  paymentStatus?: "captured" | "free"
}

/** Check if user is already enrolled in a course */
export async function checkEnrollment(userId: string, courseId: string): Promise<boolean> {
  const snap = await getDoc(doc(db, "enrollments", `${userId}_${courseId}`))
  return snap.exists()
}

/** Write enrollment to Firestore after successful payment or free access */
export async function createEnrollment(data: Enrollment): Promise<void> {
  const enrollmentId = `${data.userId}_${data.courseId}`
  await setDoc(doc(db, "enrollments", enrollmentId), {
    ...data,
    enrolledAt: serverTimestamp(),
  })
  // Increment course student count
  try {
    await updateDoc(doc(db, "courses", data.courseId), {
      students: increment(1),
    })
  } catch (_) {}
}
